import styles from "./addBooking.module.css";
import { useForm } from "react-hook-form";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import moment from "moment";
import { FormControlLabel, Checkbox } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authData, getCompanySlug } from "../../../components/GetAuth";
import { useEffect, useState } from "react";

function Step4({ bookingData, backToTab, setLoading, setSnackbarMessage, setSnackbarType, setSnackbarOpen, booking_id }) {
  const auth = authData();
  const companySlug = getCompanySlug();
  const navigate = useNavigate();
  const [SubTotal, setSubTotal] = useState(0);
  const [Total, setTotal] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);
  const [subTotalNew, setSubTotalNew] = useState(0);
  const [productRDiscount, setProductRDiscount] = useState(0);

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onChange" });

  useEffect(() => {
    let subtotalTemp = 0;
    let deliverySubtotalTemp = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;

    bookingData?.delivery_products?.forEach((item) => {
      subtotalTemp += parseFloat(item.total);
    });
    setSubTotal(subtotalTemp);

    setDiscountVal(bookingData?.discountVal);
    setDiscountAmount(bookingData?.discountAmount);
    setReferralDiscount(bookingData?.referralDiscount);

    if (bookingData?.discountAmount) {
      discountTemp = bookingData?.discountAmount;
    }

    if (bookingData?.referralDiscount) {
      discountTemp2 = bookingData?.referralDiscount;
    }

    let subTotalNewTwmp = bookingData.products.reduce((sum, item) => {
      if (parseFloat(bookingData?.discountVal) > 0) {
        let newDisc = ((parseFloat(item.total) * parseFloat(bookingData?.discountVal)) / 100);
        newDisc = Math.round(newDisc * 100) / 100;

        return sum + parseFloat(item.total) - newDisc;
      }
      return sum + parseFloat(item.total);
    }, 0);

    setSubTotalNew(subTotalNewTwmp);

    setTotal(subtotalTemp + deliverySubtotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
  }, [bookingData]);

  useEffect(() => {
    if (bookingData?.referralDiscount) {
      if (parseFloat(bookingData?.referralDiscount) > 0 && subTotalNew > 0) {
        let refDiscP = parseFloat(bookingData?.referralDiscount) / parseFloat(subTotalNew);
        refDiscP = Math.round(refDiscP * 10000) / 10000;

        setProductRDiscount(refDiscP);
      }
    }
  }, [bookingData?.referralDiscount, subTotalNew]);

  const onSubmit = (data) => {
    let noOfItems = bookingData.delivery_products.length;
    let deliverySubTotal = 0;
    let subTotal = 0;

    let products = bookingData.delivery_products.map((item) => {
      let newTotal = parseFloat(item.total);
      subTotal += parseFloat(item.total);
      let newDisc = 0;
      if (discountVal > 0) {
        let newDisc1 = ((newTotal * discountVal) / 100);
        newDisc1 = Math.round(newDisc1 * 100) / 100;

        newDisc += newDisc1;
        newTotal = newTotal - newDisc1;
      }
      if (productRDiscount > 0) {
        let newDisc2 = (newTotal * productRDiscount);
        newDisc2 = Math.round(newDisc2 * 100) / 100;

        newDisc += newDisc2;
        newTotal = newTotal - newDisc2;
      }

      let priceNew = item.price;
      if (item?.item_id === 0) {
        priceNew = parseFloat(item.total) / parseInt(item.quantity);
        priceNew = priceNew.toFixed(2)
      }

      return {
        product_id: item?.item_id,
        product_title: item?.item_name,
        price: priceNew,
        quantity: item.quantity,
        subtotal: item.total,
        discount: newDisc,
        sub_amount: newTotal
      };
    });

    let postData = {
      customer_id: bookingData?.customer_id,
      description: bookingData?.notes,
      no_of_items: noOfItems,
      insurance: bookingData?.insurance,
      company_shipping: bookingData?.company_shipping,
      company_name: bookingData?.company_name,
      registered_company: bookingData?.registered_company,
      pickup_date: moment(bookingData?.pickup_date).format("YYYY-MM-DD"),
      total: subTotal + deliverySubTotal - discountAmount - referralDiscount,
      amount: subTotal,
      post_code: bookingData?.pickUpData?.post_code,
      products: products,
      pickUpData: bookingData?.pickUpData,
      is_delivery: 1,
      discount_val: discountVal,
      discount_amount: discountAmount,
      referral_discount: referralDiscount
    };

    setLoading(true);

    if (booking_id) {
      axios.post(process.env.REACT_APP_API_URL + "v1/delivery-bookings/" + booking_id, postData, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          navigate("/" + companySlug + "/booking/list");
        }
      }).catch((error) => {
        setLoading(false);
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/delivery-bookings", postData, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          navigate("/" + companySlug + "/booking/list");
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
  }

  return (<>
    <div className={`${styles.CustomWidth}`}>
      <div className={`${styles.SummerySec}`}>
        <div className={`${styles.SummerySecUnder}`}>
          <div className={`${styles.SummerySecRow}`}>
            <div className={`${styles.SummerySecFull}`}>
              <p>Customer Name:</p>
              <p>{bookingData?.user_id?.label}</p>
            </div>
            <div className={`${styles.SummerySecHalf} ${styles.SummerySecHalf1}`} style={{ width: '100%' }}>
              <p className={`${styles.StepBoxTitle2}`}>CONFIRM YOUR USER DETAILS</p>
              <ul className={`${styles.SummeryListSec}`}>
                <li style={{ paddingLeft: '12px' }}>
                  <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.name}</p>
                </li>
                <li style={{ paddingLeft: '12px' }}>
                  <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.address}</p>
                </li>
                <li style={{ paddingLeft: '12px' }}>
                  <p className={`${styles.SummeryHeadTitle}`}>Post Code:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.post_code}</p>
                </li>
                <li style={{ paddingLeft: '12px' }}>
                  <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.phone && formatPhoneNumberIntl(bookingData?.pickUpData?.phone)}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <p className={`${styles.StepBoxTitle}`}>CONFIRM YOUR ITEM DETAILS</p>
      <div className={`${styles.TableSec}`} style={{ marginBottom: '30px' }}>
        <table>
          <tr style={{ background: "#ef233c", color: "#fff" }}>
            <td className={`${styles.TableHead}`} style={{ color: "#fff", paddingLeft: "5px" }}>Delivery Item</td>
            <td className={`${styles.TableHead}`} style={{ color: "#fff" }}>Quanity</td>
            <td className={`${styles.TableHead}`} style={{ color: "#fff", paddingRight: "5px" }}>Total</td>
          </tr>
          {bookingData?.delivery_products?.map((item) => {
            let discTemp = 0;
            let newTotal = (parseFloat(item.total));
            if (discountVal > 0) {
              let discTemp1 = ((newTotal * discountVal) / 100);
              discTemp1 = Math.round(discTemp1 * 100) / 100;

              discTemp += discTemp1;
              newTotal = newTotal - discTemp1;
            }

            if (productRDiscount > 0) {
              let newDisc2 = (newTotal * productRDiscount);
              newDisc2 = Math.round(newDisc2 * 100) / 100;

              discTemp += newDisc2;
            }

            return (<tr style={{ background: "#D1E7FC" }}>
              <td className={`${styles.TableCon}`} style={{ paddingLeft: "5px", borderBottom: "1px solid #fff" }}>{item?.item_name}</td>
              <td className={`${styles.TableCon}`} style={{ borderBottom: "1px solid #fff" }}>{item?.quantity}</td>
              <td className={`${styles.TableCon}`} style={{ paddingRight: "5px", borderBottom: "1px solid #fff" }}>
                &pound; {parseFloat(item.total).toFixed(2)}
                {discountVal > 0 && <>
                  <br />
                  <p style={{ fontSize: '12px' }}>(-&pound; {parseFloat(discTemp).toFixed(2)})</p>
                </>}
              </td>
            </tr>);
          })}
          <tr>
            <td colSpan="2" className={`${styles.TableCon}`}>
              <p className={`${styles.SummeryPPTI}`}>Order Subtotal:</p>
              {discountVal > 0 && <p className={`${styles.SummeryPPTI}`}>Membership Discount({discountVal}%):</p>}
              {referralDiscount > 0 && <p className={`${styles.SummeryPPTI}`}>Referral Discount:</p>}
              <p className={`${styles.SummeryPPTI}`}>Total VAT:</p>
              <p className={`${styles.SummeryPPTI}`}>Insurance Charges:</p>
              <p className={`${styles.SummeryPPTI} ${styles.Big}`}>Total:</p>
            </td>
            <td className={`${styles.TableCon}`}>
              <p className={`${styles.SummeryPPTE}`}>£{SubTotal.toFixed(2)}</p>
              {discountVal > 0 && <p className={`${styles.SummeryPPTE}`}>-£{discountAmount.toFixed(2)}</p>}
              {referralDiscount > 0 && <p className={`${styles.SummeryPPTE}`}>-£{referralDiscount.toFixed(2)}</p>}
              <p className={`${styles.SummeryPPTE}`}>£{VATCharge.toFixed(2)}</p>
              <p className={`${styles.SummeryPPTE}`}>£{InsuranceCharge.toFixed(2)}</p>
              <p className={`${styles.SummeryPPTE} ${styles.Big}`}>£{Total.toFixed(2)}</p>
            </td>
          </tr>
        </table>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>To be collected:</p>
        <p className={`${styles.TableConSecText}`}>{moment(bookingData.pickup_date).format("ddd MMM D, YYYY")}</p>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>Booking Notes:</p>
        <p className={`${styles.TableConSecText}`}>{bookingData?.notes}</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControlLabel
          control={<Checkbox {...register("is_accept", { required: true })} />}
          label="I confirm that the order summary above is correct *"
          className={`${styles.CheckBox} CheckBox`}
        />
        {errors?.is_accept && (<p className={`${styles.ErrorM}`}>Please accept terms & condition</p>)}

        <div className={`${styles.StepBUSec}`}>
          <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
          <button type="submit" className={`${styles.Next}`}>Confirm Booking</button>
        </div>
      </form>
    </div>
  </>);
}

export default Step4;